import { defineComponent, h } from 'vue';
import { QLinearProgress } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import utils from '../../Shared/utils.jsx';

export default defineComponent({
    name: 'cc-progress-bar',
    components: { QLinearProgress },
    mixins: [BaseComponent],
    data: function () {
        return {
            tooltipEval: null,
            tooltipPlacementEval: null,
            disabledEval: null,
            objectFitEval: null,
            color_fn: null,
            value_fn: null,
            buffervalue_fn: null,
        };
    },
    computed: {
        style() {
            const hints = utils.resolveStyleHints(this.styleHints, this);
            const size0 = this.sizeStyle;
            return {
                ...hints,
                ...size0,
                overflow: 'none',
            };
        },
        tooltip() {
            try {
                if (this.tooltipEval === null && this.controlData.Tooltip)
                    this.tooltipEval = utils.compile(this, this.Translate(this.controlData.Tooltip));
                if (this.tooltipEval)
                    return utils.evaluate(this.tooltipEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Tooltip could not evaluate expression: ' + this.controlData.Tooltip + '; ' + e);
                return '';
            }
        },
        tooltipPlacement() {
            try {
                if (this.tooltipPlacementEval === null && this.controlData.TooltipPlacement)
                    this.tooltipPlacementEval = utils.compile(this, this.controlData.TooltipPlacement);
                let placement = '';
                if (this.tooltipPlacementEval)
                    placement = utils.evaluate(this.tooltipPlacementEval, this);
                return placement.split('-')[0].toLowerCase() || 'top';
            }
            catch (e) {
                utils.warn('TooltipPlacement could not evaluate expression: ' + this.controlData.TooltipPlacement + '; ' + e);
                return '';
            }
        },
        color() {
            if (!this.color_fn && this.controlData.Color)
                this.color_fn = utils.compile(this, this.controlData.Color);

            return this.color_fn ? utils.evaluate(this.color_fn, this) : undefined;
        },
        value() {
            if (!this.value_fn && this.controlData.ValueExpression)
                this.value_fn = utils.compileExpression(this, this.controlData.ValueExpression);

            return (this.value_fn ? utils.evaluate(this.value_fn, this) : 0) / 100.0;
        },
        bufferValue() {
            if (!this.buffervalue_fn && this.controlData.BufferValueExpression)
                this.buffervalue_fn = utils.compileExpression(this, this.controlData.BufferValueExpression);

            return (this.buffervalue_fn ? utils.evaluate(this.buffervalue_fn, this) : 100) / 100.0;
        },
        height() {
            if (this.controlData.SizeOptions && this.controlData.SizeOptions.Height && this.controlData.SizeOptions.Height.Mode == 'Fixed')
                return this.controlData.SizeOptions.Height.Value || 4;
            else
                return 4;
        },
    },
    methods: {
        async preRenderComplete() {
            this.finishRenderHandler(this);
        },
        getContent(value) {
            if (!this.content_fn && this.controlData.Content)
                this.content_fn = utils.compile(this, this.controlData.Content, false, 'value');

            return this.content_fn ? utils.evaluate(this.content_fn, this, false, null, false, value) : null;
        },
    },
    render() {
        if (!this.todisplay)
            return null;

        try {
            const hasContent = this.controlData.Content;

            let item = (
                <div
                    v-show={this.isvisible}
                    style={[this.style, { width: '100%', height: '100%' }]}
                    class={{ 'c-ProgressBar': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                >
                    <QLinearProgress
                        value={this.value}
                        buffer={this.bufferValue}
                        size={`${this.height}px`}
                        color={this.color}
                        indeterminate={this.controlData.Indeterminate}
                        reverse={this.controlData.Reverse}
                        rounded={this.controlData.Rounded}
                        stripe={this.controlData.Striped}
                    >
                        {hasContent && (
                            <div class="absolute-full flex flex-center">
                                <span class="text-black" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                    {this.getContent(this.value)}
                                </span>
                            </div>)
                            }
                    </QLinearProgress>
                </div>
            );

            return item;
        }
        catch (e) {
            utils.error('ProgressBar Render failed', e);
            return <div>ProgressBar Failed to Render {e}</div>;
        }
    },
});
